import { Spin } from 'antd'
import { Redirect, Route, Router, Switch } from 'dva/router'
import React, { lazy, Suspense } from 'react'
const MainLaytout = lazy(() => import('@/layouts/MainLaytout'))
const AccoutnLayout = lazy(() => import('@/layouts/AccoutnLayout'))
const Login = lazy(() => import('@/pages/account/login'))

// 概览
const Cockpit = lazy(() => import('@/pages/overview/cockpit'))
const Membership = lazy(() => import('@/pages/overview/membership'))
const Payment = lazy(() => import('@/pages/overview/payment'))

// 入会管理
const MemberService = lazy(() => import('@/pages/memberservice'))
const MemberDetail = lazy(() => import('@/pages/memberservice/detail'))
const MemberTodoList = lazy(() => import('@/pages/memberservice/todoList'))
const MemberListAudit = lazy(() => import('@/pages/memberservice/audit'))
const MemberListReply = lazy(() => import('@/pages/memberservice/reply'))
const MemberListPayconfirm = lazy(() => import('@/pages/memberservice/payconfirm'))
const PayconfirmDetail = lazy(() => import('@/pages/memberservice/payconfirm/detail'))
const MemberListCertificate = lazy(() => import('@/pages/memberservice/certificate'))

// 会费管理
const MemberTaxList = lazy(() => import('@/pages/membertax/list'))
const MemberTaxBill = lazy(() => import('@/pages/membertax/bill'))

// 会员管理
const MemberList = lazy(() => import('@/pages/member/list'))
const ChangeCertificate = lazy(() => import('@/pages/member/changeCertificate'))
const SendCertificate = lazy(() => import('@/pages/member/sendCertificate'))
const Changes = lazy(() => import('@/pages/member/changes'))
const Abnormal = lazy(() => import('@/pages/member/abnormal'))

// 个人证书
const TrainingCert = lazy(() => import('@/pages/member/trainingCert'))

// 消息管理
const Message = lazy(() => import('@/pages/message'))
const MessageReply = lazy(() => import('@/pages/message/messageReplay'))

// 公告
const Notice = lazy(() => import('@/pages/notice'))

// 系统管理
const SystemRole = lazy(() => import('@/pages/system/role'))
const SystemUserData = lazy(() => import('@/pages/system/userData'))
const AssociateMember = lazy(() => import('@/pages/system/associateMember'))
const Org = lazy(() => import('@/pages/system/org'))
const FeeConfig = lazy(() => import('@/pages/system/feeConfig'))

// 个人会员
const PersonalPendingList = lazy(() => import('@/pages/personal/PendingList'))
const PersonalMemberList = lazy(() => import('@/pages/personal/MemberList'))

import Cert from '@/pages/cert'
import CertSearch from '@/pages/cert/search'
import Train from '@/pages/train'
import TrainSearch from '@/pages/train/search'

function BasicRouter({ history, app }) {
  return (
    <Suspense
      fallback={
        <div className="suspenseLoading">
          <Spin />
        </div>
      }
    >
      <Router history={history}>
        <Switch>
          <Route path="/common/certificate/search" component={CertSearch} />
          <Route path="/cert/:code" component={Cert} />
          <Route path="/common/train/search" component={TrainSearch} />
          <Route path="/common/train/detail" component={Train} />
          <Route
            path="/account"
            render={() => (
              <AccoutnLayout>
                <Route exact path="/account/login" component={Login} />
              </AccoutnLayout>
            )}
          />

          <Route path="/" exact render={() => <Redirect to="/overview/cockpit" />} />
          {/* 概览 */}
          <Route
            path="/overview"
            render={() => (
              <MainLaytout>
                <Route key="cockpit" exact path="/overview/cockpit" component={Cockpit} />
                <Route key="membership" exact path="/overview/membership" component={Membership} />
                <Route key="payment" exact path="/overview/payment" component={Payment} />
              </MainLaytout>
            )}
          />

          {/* 入会管理 */}
          <Route
            path="/memberservice"
            render={() => (
              <MainLaytout>
                <Route key="todoList" exact path="/memberservice" component={MemberTodoList} />
                <Route
                  key="audit"
                  exact
                  path="/memberservice/list/audit"
                  component={MemberListAudit}
                />
                <Route
                  key="reply"
                  exact
                  path="/memberservice/list/reply"
                  component={MemberListReply}
                />
                <Route
                  key="payconfirm"
                  exact
                  path="/memberservice/list/payconfirm"
                  component={MemberListPayconfirm}
                />
                <Route
                  key="certificate"
                  exact
                  path="/memberservice/list/certificate"
                  component={MemberListCertificate}
                />
                {/* <Route key="memberList" exact path="/memberservice/list/:type" component={MemberService} /> */}
                <Route
                  key="memberdetail"
                  path="/memberservice/memberdetail/:id"
                  component={MemberDetail}
                />
                <Route
                  key="payconfirmDetail"
                  path="/memberservice/payconfirmDetail/:id"
                  component={PayconfirmDetail}
                />
                <Route
                  key="personal-pending-list"
                  exact
                  path="/memberservice/personal/pending-list"
                  component={PersonalPendingList}
                />
              </MainLaytout>
            )}
          />

          {/* 会费管理 */}
          {/* <Route
            path="/membertax"
            render={() => (
              <MainLaytout>
                <Route
                  key="membertaxList"
                  exact
                  path="/membertax/membertaxList"
                  component={MemberTaxList}
                />
                <Route
                  key="membertaxBill"
                  exact
                  path="/membertax/membertaxBill"
                  component={MemberTaxBill}
                />
              </MainLaytout>
            )}
          /> */}

          {/* 会员管理 */}
          <Route
            path="/member"
            render={() => (
              <MainLaytout>
                <Route
                  key="memberlist"
                  exact
                  path="/member/enterprise/MemberList"
                  component={MemberList}
                />
                <Route
                  key="memberlistTax"
                  exact
                  path="/member/enterprise/membertaxList"
                  component={MemberTaxList}
                />
                <Route
                  key="changeCertificate"
                  exact
                  path="/member/enterprise/changeCertificate"
                  component={ChangeCertificate}
                />
                <Route
                  key="sendCertificate"
                  path="/member/enterprise/sendCertificate"
                  component={SendCertificate}
                />
                <Route key="memberChanges" path="/member/enterprise/changes" component={Changes} />
                <Route key="abnormal" path="/member/enterprise/abnormal" component={Abnormal} />
                <Route
                  key="personal-member-list"
                  exact
                  path="/member/personal/member-list"
                  component={PersonalMemberList}
                />
              </MainLaytout>
            )}
          />

          {/* 消息管理 */}
          {/* <Route
            path="/message"
            render={() => (
              <MainLaytout>
                <Route key="messageList" exact path="/message/messageList" component={Message} />
                <Route
                  key="messageReply"
                  exact
                  path="/message/messageReply"
                  component={MessageReply}
                />
              </MainLaytout>
            )}
          /> */}

          {/* 内容管理 */}
          <Route
            path="/content"
            render={() => (
              <MainLaytout>
                <Route key="contentList" exact path="/content/notice" component={Notice} />
                <Route
                  key="messageList"
                  exact
                  path="/content/message/messageList"
                  component={Message}
                />
                <Route
                  key="messageReply"
                  exact
                  path="/content/message/messageReply"
                  component={MessageReply}
                />
              </MainLaytout>
            )}
          />

          {/* 系统管理 */}
          <Route
            path="/system"
            render={() => (
              <MainLaytout>
                <Route key="role" exact path="/system/role" component={SystemRole} />
                <Route key="userData" exact path="/system/userData" component={SystemUserData} />
                <Route
                  key="associateMember"
                  exact
                  path="/system/associateMember"
                  component={AssociateMember}
                />
                <Route key="org" exact path="/system/org" component={Org} />
                <Route key="feeConfig" exact path="/system/feeConfig" component={FeeConfig} />
              </MainLaytout>
            )}
          />

          {/* 证书 */}
          <Route
            key="trainingCert"
            path="/trainingCert"
            render={() => {
              return (
                <MainLaytout>
                  <TrainingCert />
                </MainLaytout>
              )
            }}
          />

          {/* 个人会员 */}
          {/* <Route
            path="/personal"
            render={() => (
              <MainLaytout>
                <Route
                  key="personal-pending-list"
                  exact
                  path="/personal/pending-list"
                  component={PersonalPendingList}
                />
                <Route
                  key="personal-member-list"
                  exact
                  path="/personal/member-list"
                  component={PersonalMemberList}
                />
              </MainLaytout>
            )}
          /> */}
          <Route
            path="/enterprise"
            render={() => (
              <MainLaytout>
                <Route
                  key="audit"
                  exact
                  path="/enterprise/entry/audit"
                  component={MemberListAudit}
                />
                <Route
                  key="payconfirm"
                  exact
                  path="/enterprise/entry/payconfirm"
                  component={MemberListPayconfirm}
                />
                <Route
                  key="certificate"
                  exact
                  path="/enterprise/entry/certificate"
                  component={MemberListCertificate}
                />
                <Route
                  key="memberlist"
                  exact
                  path="/enterprise/mgmt/MemberList"
                  component={MemberList}
                />
                <Route
                  key="memberlistTax"
                  exact
                  path="/enterprise/mgmt/membertaxList"
                  component={MemberTaxList}
                />
                <Route
                  key="changeCertificate"
                  exact
                  path="/enterprise/mgmt/changeCertificate"
                  component={ChangeCertificate}
                />
                <Route
                  key="memberChanges"
                  exact
                  path="/enterprise/mgmt/changes"
                  component={Changes}
                />
                <Route key="abnormal" exact path="/enterprise/mgmt/abnormal" component={Abnormal} />
              </MainLaytout>
            )}
          />
        </Switch>
      </Router>
    </Suspense>
  )
}

export default BasicRouter
